module.exports = __webpack_public_path__ + "static/1-97c8ddbd1c7aaa2817b2c35def94ea6b.jpeg";